import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

/** Common shell for every public page — handles Navbar + Footer + min-height. */
export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#F8F9FA] flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
